import React from 'react';
import classNames from 'classnames';
import styles from './post-list-compact-header.scss';

const PostListCompactHeader = () => (
  <thead>
    <tr>
      <th className={classNames(styles.authorHeader, styles.left)} />
      <th className={classNames(styles.titleHeader, styles.left, 'forum-text-color')} />
      <th className={styles.moreButtonHeader} />
    </tr>
  </thead>
);

export default PostListCompactHeader;
